const app_params = {
    basepath: '/opac', 
    version: '10.1.0',
    gaTag: 'G-TAG',
};

export default app_params;